@if (loading) {
    <div class="h-100">
        <app-spinner
            [fullscreen]="false"
        ></app-spinner>
    </div>
} @else if (error) {
    <app-error-ficha [mensaje]="error" textoVolver="Ir a Inicio" (reintentar)="ngOnInit()" (volver)="irAInicio()"></app-error-ficha>
} @else {
    <app-core
        [type]="type"
        [titleForm]="titleForm"
        [items]="cargos"
    >
    </app-core>
}
